import Vue from 'vue/dist/vue.esm';

// LOADING GLOBAL COMPONENTS



  
	
	import componentAccordion from "/var/www/myapp/app/webpacker/javascripts/components/global/accordion.vue";
	Vue.component("vue-accordion", componentAccordion);

  
	
	import componentDynamicList from "/var/www/myapp/app/webpacker/javascripts/components/global/dynamicList.vue";
	Vue.component("vue-dynamic-list", componentDynamicList);

  
	
	import componentDynamicListItem from "/var/www/myapp/app/webpacker/javascripts/components/global/dynamicListItem.vue";
	Vue.component("vue-dynamic-list-item", componentDynamicListItem);

  
	
	import componentModal from "/var/www/myapp/app/webpacker/javascripts/components/global/modal.vue";
	Vue.component("vue-modal", componentModal);

  
	
	import componentMyMoney from "/var/www/myapp/app/webpacker/javascripts/components/global/myMoney.vue";
	Vue.component("vue-my-money", componentMyMoney);

  
	
	import componentMyMultiSelect from "/var/www/myapp/app/webpacker/javascripts/components/global/myMultiSelect.vue";
	Vue.component("vue-my-multi-select", componentMyMultiSelect);

  
	
	import componentMySelect from "/var/www/myapp/app/webpacker/javascripts/components/global/mySelect.vue";
	Vue.component("vue-my-select", componentMySelect);

  
	
	import componentSidebar from "/var/www/myapp/app/webpacker/javascripts/components/global/sidebar.vue";
	Vue.component("vue-sidebar", componentSidebar);


// LOADING PAGE SPECIFIC COMPONENTS
import companyFormCreateComponent from './admin/company/formCreateComponent';
	Vue.component("vue-company-form-create", companyFormCreateComponent);

import catalogSelectTagComponent from './admin/catalog/selectTag';
	Vue.component('vue-catalog-select-tag', catalogSelectTagComponent);

import catalogFormCreateComponent from './admin/catalog/formCreateComponent';
	Vue.component('vue-catalog-form-create', catalogFormCreateComponent);

import associationFormCreateComponent from './admin/association/formCreateComponent';
	Vue.component('vue-association-form-create', associationFormCreateComponent);

import catalogFormComponent from './catalog/catalogCreateComponent';
	Vue.component('vue-catalog-create', catalogFormComponent);

import landingPageComponent from './landing/landingPageComponent;';
	Vue.component('vue-landing-page', landingPageComponent);

import multiSelect from './global/myMultiSelect';
	Vue.component('vue-my-multiselect', multiSelect);

import mySelect from './global/mySelect';
	Vue.component('vue-myselect', mySelect);

import modalsearchComponent from './search/modalsearchComponent';
	Vue.component('vue-modal-search', modalsearchComponent);

import businessProfileComponent from './search/businessProfileComponent';
	Vue.component('vue-business-profile', businessProfileComponent);

import companyDatailsComponent from './search/companyDatailsComponent';
	Vue.component('vue-company-details', companyDatailsComponent);

import authenticationResendCountdown from './search/authenticationResendCountdown';
	Vue.component('vue-authentication-resend-countdown', authenticationResendCountdown);

import authenticationRedirectCountdown from './search/authenticationRedirectCountdown';
	Vue.component('vue-authentication-redirect-countdown', authenticationRedirectCountdown);
